import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button as HeroButton } from '@heroui/react';
export const Button = React.forwardRef((props, ref) => {
    return _jsx(HeroButton, { ...props, ref: ref });
});
Button.displayName = 'Button';
export default Button;
//# sourceMappingURL=Button.js.map